import React from 'react';
import { CircularProgress } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';

export const getStatusIcon = (status) => {
  switch (status) {
    case 'pending':
      return <CircularProgress size={20} />;
    case 'downloading':
      return <CircularProgress size={20} color="primary" />;
    case 'completed':
      return <CheckCircle color="success" />;
    case 'error':
      return <Error color="error" />;
    default:
      return <CircularProgress size={20} />;
  }
};

export const getStatusText = (status) => {
  switch (status) {
    case 'pending':
      return 'Pending';
    case 'downloading':
      return 'Downloading...';
    case 'completed':
      return 'Completed';
    case 'error':
      return 'Failed';
    default:
      return 'Unknown';
  }
};